import moment from 'moment/moment';

const formatDate = (date, format = 'DD/MM/YYYY') => moment(date).format(format);
export default formatDate;
